import React, { Component } from 'react'
import axios from 'axios';
import Section from './Section.js'
import RenaperStepErrorMessage from './RenaperStepErrorMessage';
import CustomSpinner from './CustomSpinner.js';

require(`../assets/${process.env.PAGE}/css/components/RenaperAddTramitNumber.css`);

class RenaperAddTramitNumber extends Component {
  constructor(props){
    super(props);

    this.state = {
        file: null,
        loading: false,
        stepError: false,
        error: false,
        tramit_number: null,
    }

    this.handleChange = this.handleChange.bind(this);
  }

  escapeRegExp(string) {
    return string.replace(/[a-zA-Z.!¡*+\-?^${}()|[\]\\]/g,'');
  }

  handleInputChange = (event) => {
    this.setState({
      ...this.state,
      tramit_number: this.escapeRegExp(event.target.value),
      error: (event.target.value.length == 11 || event.target.value.length == 15) ? false : this.state.error
    });
  }

  handleChange(event){
    event.preventDefault()
    if (this.state.tramit_number && (this.state.tramit_number.length == 11 || this.state.tramit_number.length == 15)){
      this.setState({
        ...this.state,
        loading: true,
      });

      const ROOT_URL = process.env.API_URL;

      const config = {
          headers:
              {
                  'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken'),
              }
      };

      axios.post(`${ROOT_URL}/identity/renaper/tramit_number`, {"tramit_number" : this.state.tramit_number}, config)
      .then((response)=> {
        if(response.status >= 200 && response.status <= 300){
          if (!response.data.status) {
            this.setState({
              ...this.state,
              stepError: true
            })
            setTimeout(this.props.onRollback, 5 * 1000);
          }
          else {
            setTimeout(this.props.onFinish(), 5 * 1000)
          }
        }
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          stepError: true
        })
        setTimeout(this.props.onRollback, 5 * 1000);
      });
    }else {
      this.setState({
        ...this.state,
        error: true
      })
    }
  }

  render() {
    const { loading, stepError, error } = this.state;

    const errorMessage = (<RenaperStepErrorMessage message="Numero de tramite incorrecto. Por favor reintenta el paso nuevamente"/>);
    return (
      <div style={{
        position: "relative",
        display: "block",
        width: "100%",
        height: "100%",
        overflowY: "scroll",
        background: "#0a2540",
      }}>
      <Section className="intro_form">
          <div className="row">
            <div className="col-sm-12 col-md-7 col-lg-10 col-md-offset-3 col-lg-offset-1 text-center">
                <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
            </div>
            <div className="col-sm-10 col-md-7 col-lg-10 col-sm-offset-1 col-md-offset-3 col-lg-offset-1 text-center renaper-message">
              <h4><b>Ingresá el Número de Trámite del DNI</b></h4>
            </div>
            <div className="col-sm-12 col-md-7 col-lg-8 col-md-offset-3 col-lg-offset-2 text-center tramit-number-container">
                <form onSubmit={this.handleChange} className="pvc-form">
                  {loading && <CustomSpinner message={ stepError ? errorMessage : 'Estamos analizando los datos. Por favor espere...' } />}
                    <div className={`form-group ${error ? 'has-error' : ''}`}>
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <div className="form-group">
                            <input type="text" placeholder="Número de Trámite" className="form-control" value={this.state.tramit_number} onChange={this.handleInputChange} name="tramit_number"></input>
                          </div>
                          <div className="help-block">
                            {((error && <span>{'El número de trámite no es válido.'}</span>))}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                        <button type="submit" className="btn btn-warning btn-lg pd-button pd-form">Seguir</button>
                      </div>
                    </div>
                </form>
                <div className="col-sm-10 col-md-10 col-lg-8 col-sm-offset-1 col-md-offset-1 col-lg-offset-2 text-center dni-img-container">
                  <img alt="Numero de Trámite"  src={require(`../assets/${process.env.PAGE}/img/dni-tramite.png`)}/>
                </div>
            </div>
          </div>
      </Section>
      </div>
    )
  }
}
module.exports = RenaperAddTramitNumber;


/** WEBPACK FOOTER **
 ** ./src/components/RenaperAddTramitNumber.js
 **/